import { configure } from 'mobx';

import { useEffect, Fragment } from 'react';
import ReactDOM from 'react-dom/client';
import { observer } from 'mobx-react';
import axios from 'axios';
import * as serviceWorker from './serviceWorker';
import { appStore } from './stores/app.store';
import { playBarStore } from './stores/play.bar.store';
import { LoginForm } from './components/Login';
import { App } from './App';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import './styles.css';
import 'bootstrap-css-only';
import { ToastProvider } from 'react-toast-notifications';
import { Spinner } from './components/Spinner';

configure({ enforceActions: false });

axios.interceptors.request.use((config) => {
  return config;
}, (error) => Promise.reject(error));

const BlockWrapper = observer(() => {
  useEffect(() => {
    if (appStore.newUpdateAvailable || appStore.newUpdateDownloaded) {
      document.getElementsByTagName('body')[0].style.height = '100%';
    }
    return () => {
      document.getElementsByTagName('body')[0].style.height = 'auto';
    };
  }, []);

  const handleInstall = () => {
    if (window.ipcRenderer) {
      window.ipcRenderer.send('trigger-install', true);
    }
  };

  const shouldShowModal =
    appStore.newUpdateAvailable || appStore.newUpdateDownloaded;

  if (shouldShowModal === false) {
    return null;
  }

  const resolveContentToRender = () => {
    if (appStore.newUpdateAvailable) {
      return (
        <div className='update-message-content'>
          <h1>Descargando Actualización.</h1>
          <p>
            Descargando datos, esto puede tomar unos minutos dependiendo de su
            velocidad de internet.
          </p>
          <Spinner />
        </div>
      );
    }
    if (appStore.newUpdateDownloaded) {
      return (
        <div className='update-message-content'>
          <h1>Nueva actualización.</h1>
          <p>
            Hay una nueva actualización necesaria para su player, presione
            "Actualizar" para poder continuar.
          </p>
          <button className='form-button' onClick={handleInstall}>
            Actualizar
          </button>
        </div>
      );
    }
  };

  return (
    <BlockUi tag='div' blocking={shouldShowModal}>
      {resolveContentToRender()}
    </BlockUi>
  );
});

const SetupApp = observer(() => {
  if (appStore.sessionToken) {
    return (
      <Fragment>
        <BlockWrapper />
        <App appStore={appStore} playBarStore={playBarStore} />
      </Fragment>
    );
  }
  return (
    <ToastProvider>
      <BlockWrapper />
      <LoginForm appStore={appStore} />
    </ToastProvider>
  );
});

ReactDOM.createRoot(document.getElementById('root')).render(<SetupApp />);

serviceWorker.unregister();
